// src/utils/cloudbase.js 【修复后版本】
import tcb from '@cloudbase/js-sdk'

// 初始化CloudBase，填你的环境ID
const app = tcb.init({
    env: 'web-2gpx1p8e8259ddd9'
})

// 【新版SDK正确的匿名登录语法】替换旧的anonymousAuthProvider
async function cloudLogin() {
    try {
        const auth = app.auth({ persistence: 'local' }) // 持久化登录状态
        await auth.signInAnonymously() // 新版核心：直接调用signInAnonymously
        console.log('CloudBase login✅')
    } catch (err) {
        console.error('CloudBase login❌：', err)
        throw err
    }
}

// 先登录再暴露数据库实例
cloudLogin().then(() => {
    window.$cloudDb = app.database()
})

export default {
    app,
    db: app.database()
}


